import { ReservationExtended } from '@opanuj/shared/types';
import { useClientsList } from './useClients';
import { useMemo } from 'react';
import { useReservationsList } from './useReservations';
import { useSlotsList } from './useSlots';

export const useReservationsExtended = () => {
	const [reservations, reservationsLoading, reservationsError] = useReservationsList();
	const [clients, clientsLoading, clientsError] = useClientsList();
	const [slots, slotsLoading, slotsError] = useSlotsList();

	const reservationsExtended = useMemo<ReservationExtended[]>(() => {
		if (!reservations?.length) {
			return [];
		}

		return reservations.flatMap((reservation) => {
			const client = clients?.find((clientItem) => clientItem.uid === reservation.uid);
			return (reservation.lessons ?? []).map((lesson) => {
				const slot = slots?.find((slotItem) => slotItem.id === lesson.slot);
				return {
					reservation,
					lesson,
					slot,
					client,
				};
			});
		});
	}, [clients, reservations, slots]);

	const loading = reservationsLoading || clientsLoading || slotsLoading;
	const error = reservationsError || clientsError || slotsError;
	const isReady = !loading && !!reservations && !!clients && !!slots;

	return {
		reservationsExtended,
		loading,
		error,
		isReady,
	};
};
